/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './app/routes/__root'
import { Route as IndexImport } from './app/routes/index'
import { Route as TradeIndexImport } from './app/routes/trade/index'
import { Route as RewardsIndexImport } from './app/routes/rewards/index'
import { Route as ProfileIndexImport } from './app/routes/profile/index'
import { Route as PortfolioIndexImport } from './app/routes/portfolio/index'
import { Route as OrdersIndexImport } from './app/routes/orders/index'
import { Route as LoginSignupIndexImport } from './app/routes/login-signup/index'
import { Route as DepositIndexImport } from './app/routes/deposit/index'
import { Route as WithdrawConfirmIndexImport } from './app/routes/withdraw/confirm/index'
import { Route as WithdrawAmountIndexImport } from './app/routes/withdraw/amount/index'
import { Route as WithdrawAddressIndexImport } from './app/routes/withdraw/address/index'
import { Route as TradeConfirmIndexImport } from './app/routes/trade/confirm/index'
import { Route as ProfileWsolIndexImport } from './app/routes/profile/wsol/index'
import { Route as ProfileWalletSettingsIndexImport } from './app/routes/profile/wallet-settings/index'
import { Route as ProfileUsernameIndexImport } from './app/routes/profile/username/index'
import { Route as ProfileTradeSettingsIndexImport } from './app/routes/profile/trade-settings/index'
import { Route as ProfileSlippageIndexImport } from './app/routes/profile/slippage/index'
import { Route as ProfileRpcIndexImport } from './app/routes/profile/rpc/index'
import { Route as ProfileQuickTradeSettingsIndexImport } from './app/routes/profile/quick-trade-settings/index'
import { Route as ProfilePriorityFeeIndexImport } from './app/routes/profile/priority-fee/index'
import { Route as OrdersOrderIdIndexImport } from './app/routes/orders/$orderId/index'
import { Route as MigrateTokensIndexImport } from './app/routes/migrate/tokens/index'
import { Route as MigratePasswordIndexImport } from './app/routes/migrate/password/index'
import { Route as MigrateNoticeIndexImport } from './app/routes/migrate/notice/index'
import { Route as MigrateLoginIndexImport } from './app/routes/migrate/login/index'
import { Route as MigrateInvalidIndexImport } from './app/routes/migrate/invalid/index'
import { Route as MigrateForgotPasswordIndexImport } from './app/routes/migrate/forgot-password/index'
import { Route as OrdersPendingPendingOrderIdImport } from './app/routes/orders/pending/$pendingOrderId'
import { Route as ProfileWalletSettingsPrivateKeyIndexImport } from './app/routes/profile/wallet-settings/private-key/index'
import { Route as ProfileWalletSettingsManagePasskeysIndexImport } from './app/routes/profile/wallet-settings/manage-passkeys/index'
import { Route as ProfileWalletSettingsCreateSessionIndexImport } from './app/routes/profile/wallet-settings/create-session/index'
import { Route as ProfileWalletSettingsCreatePasskeyIndexImport } from './app/routes/profile/wallet-settings/create-passkey/index'

// Create/Update Routes

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const TradeIndexRoute = TradeIndexImport.update({
  path: '/trade/',
  getParentRoute: () => rootRoute,
} as any)

const RewardsIndexRoute = RewardsIndexImport.update({
  path: '/rewards/',
  getParentRoute: () => rootRoute,
} as any)

const ProfileIndexRoute = ProfileIndexImport.update({
  path: '/profile/',
  getParentRoute: () => rootRoute,
} as any)

const PortfolioIndexRoute = PortfolioIndexImport.update({
  path: '/portfolio/',
  getParentRoute: () => rootRoute,
} as any)

const OrdersIndexRoute = OrdersIndexImport.update({
  path: '/orders/',
  getParentRoute: () => rootRoute,
} as any)

const LoginSignupIndexRoute = LoginSignupIndexImport.update({
  path: '/login-signup/',
  getParentRoute: () => rootRoute,
} as any)

const DepositIndexRoute = DepositIndexImport.update({
  path: '/deposit/',
  getParentRoute: () => rootRoute,
} as any)

const WithdrawConfirmIndexRoute = WithdrawConfirmIndexImport.update({
  path: '/withdraw/confirm/',
  getParentRoute: () => rootRoute,
} as any)

const WithdrawAmountIndexRoute = WithdrawAmountIndexImport.update({
  path: '/withdraw/amount/',
  getParentRoute: () => rootRoute,
} as any)

const WithdrawAddressIndexRoute = WithdrawAddressIndexImport.update({
  path: '/withdraw/address/',
  getParentRoute: () => rootRoute,
} as any)

const TradeConfirmIndexRoute = TradeConfirmIndexImport.update({
  path: '/trade/confirm/',
  getParentRoute: () => rootRoute,
} as any)

const ProfileWsolIndexRoute = ProfileWsolIndexImport.update({
  path: '/profile/wsol/',
  getParentRoute: () => rootRoute,
} as any)

const ProfileWalletSettingsIndexRoute = ProfileWalletSettingsIndexImport.update(
  {
    path: '/profile/wallet-settings/',
    getParentRoute: () => rootRoute,
  } as any,
)

const ProfileUsernameIndexRoute = ProfileUsernameIndexImport.update({
  path: '/profile/username/',
  getParentRoute: () => rootRoute,
} as any)

const ProfileTradeSettingsIndexRoute = ProfileTradeSettingsIndexImport.update({
  path: '/profile/trade-settings/',
  getParentRoute: () => rootRoute,
} as any)

const ProfileSlippageIndexRoute = ProfileSlippageIndexImport.update({
  path: '/profile/slippage/',
  getParentRoute: () => rootRoute,
} as any)

const ProfileRpcIndexRoute = ProfileRpcIndexImport.update({
  path: '/profile/rpc/',
  getParentRoute: () => rootRoute,
} as any)

const ProfileQuickTradeSettingsIndexRoute =
  ProfileQuickTradeSettingsIndexImport.update({
    path: '/profile/quick-trade-settings/',
    getParentRoute: () => rootRoute,
  } as any)

const ProfilePriorityFeeIndexRoute = ProfilePriorityFeeIndexImport.update({
  path: '/profile/priority-fee/',
  getParentRoute: () => rootRoute,
} as any)

const OrdersOrderIdIndexRoute = OrdersOrderIdIndexImport.update({
  path: '/orders/$orderId/',
  getParentRoute: () => rootRoute,
} as any)

const MigrateTokensIndexRoute = MigrateTokensIndexImport.update({
  path: '/migrate/tokens/',
  getParentRoute: () => rootRoute,
} as any)

const MigratePasswordIndexRoute = MigratePasswordIndexImport.update({
  path: '/migrate/password/',
  getParentRoute: () => rootRoute,
} as any)

const MigrateNoticeIndexRoute = MigrateNoticeIndexImport.update({
  path: '/migrate/notice/',
  getParentRoute: () => rootRoute,
} as any)

const MigrateLoginIndexRoute = MigrateLoginIndexImport.update({
  path: '/migrate/login/',
  getParentRoute: () => rootRoute,
} as any)

const MigrateInvalidIndexRoute = MigrateInvalidIndexImport.update({
  path: '/migrate/invalid/',
  getParentRoute: () => rootRoute,
} as any)

const MigrateForgotPasswordIndexRoute = MigrateForgotPasswordIndexImport.update(
  {
    path: '/migrate/forgot-password/',
    getParentRoute: () => rootRoute,
  } as any,
)

const OrdersPendingPendingOrderIdRoute =
  OrdersPendingPendingOrderIdImport.update({
    path: '/orders/pending/$pendingOrderId',
    getParentRoute: () => rootRoute,
  } as any)

const ProfileWalletSettingsPrivateKeyIndexRoute =
  ProfileWalletSettingsPrivateKeyIndexImport.update({
    path: '/profile/wallet-settings/private-key/',
    getParentRoute: () => rootRoute,
  } as any)

const ProfileWalletSettingsManagePasskeysIndexRoute =
  ProfileWalletSettingsManagePasskeysIndexImport.update({
    path: '/profile/wallet-settings/manage-passkeys/',
    getParentRoute: () => rootRoute,
  } as any)

const ProfileWalletSettingsCreateSessionIndexRoute =
  ProfileWalletSettingsCreateSessionIndexImport.update({
    path: '/profile/wallet-settings/create-session/',
    getParentRoute: () => rootRoute,
  } as any)

const ProfileWalletSettingsCreatePasskeyIndexRoute =
  ProfileWalletSettingsCreatePasskeyIndexImport.update({
    path: '/profile/wallet-settings/create-passkey/',
    getParentRoute: () => rootRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/deposit/': {
      preLoaderRoute: typeof DepositIndexImport
      parentRoute: typeof rootRoute
    }
    '/login-signup/': {
      preLoaderRoute: typeof LoginSignupIndexImport
      parentRoute: typeof rootRoute
    }
    '/orders/': {
      preLoaderRoute: typeof OrdersIndexImport
      parentRoute: typeof rootRoute
    }
    '/portfolio/': {
      preLoaderRoute: typeof PortfolioIndexImport
      parentRoute: typeof rootRoute
    }
    '/profile/': {
      preLoaderRoute: typeof ProfileIndexImport
      parentRoute: typeof rootRoute
    }
    '/rewards/': {
      preLoaderRoute: typeof RewardsIndexImport
      parentRoute: typeof rootRoute
    }
    '/trade/': {
      preLoaderRoute: typeof TradeIndexImport
      parentRoute: typeof rootRoute
    }
    '/orders/pending/$pendingOrderId': {
      preLoaderRoute: typeof OrdersPendingPendingOrderIdImport
      parentRoute: typeof rootRoute
    }
    '/migrate/forgot-password/': {
      preLoaderRoute: typeof MigrateForgotPasswordIndexImport
      parentRoute: typeof rootRoute
    }
    '/migrate/invalid/': {
      preLoaderRoute: typeof MigrateInvalidIndexImport
      parentRoute: typeof rootRoute
    }
    '/migrate/login/': {
      preLoaderRoute: typeof MigrateLoginIndexImport
      parentRoute: typeof rootRoute
    }
    '/migrate/notice/': {
      preLoaderRoute: typeof MigrateNoticeIndexImport
      parentRoute: typeof rootRoute
    }
    '/migrate/password/': {
      preLoaderRoute: typeof MigratePasswordIndexImport
      parentRoute: typeof rootRoute
    }
    '/migrate/tokens/': {
      preLoaderRoute: typeof MigrateTokensIndexImport
      parentRoute: typeof rootRoute
    }
    '/orders/$orderId/': {
      preLoaderRoute: typeof OrdersOrderIdIndexImport
      parentRoute: typeof rootRoute
    }
    '/profile/priority-fee/': {
      preLoaderRoute: typeof ProfilePriorityFeeIndexImport
      parentRoute: typeof rootRoute
    }
    '/profile/quick-trade-settings/': {
      preLoaderRoute: typeof ProfileQuickTradeSettingsIndexImport
      parentRoute: typeof rootRoute
    }
    '/profile/rpc/': {
      preLoaderRoute: typeof ProfileRpcIndexImport
      parentRoute: typeof rootRoute
    }
    '/profile/slippage/': {
      preLoaderRoute: typeof ProfileSlippageIndexImport
      parentRoute: typeof rootRoute
    }
    '/profile/trade-settings/': {
      preLoaderRoute: typeof ProfileTradeSettingsIndexImport
      parentRoute: typeof rootRoute
    }
    '/profile/username/': {
      preLoaderRoute: typeof ProfileUsernameIndexImport
      parentRoute: typeof rootRoute
    }
    '/profile/wallet-settings/': {
      preLoaderRoute: typeof ProfileWalletSettingsIndexImport
      parentRoute: typeof rootRoute
    }
    '/profile/wsol/': {
      preLoaderRoute: typeof ProfileWsolIndexImport
      parentRoute: typeof rootRoute
    }
    '/trade/confirm/': {
      preLoaderRoute: typeof TradeConfirmIndexImport
      parentRoute: typeof rootRoute
    }
    '/withdraw/address/': {
      preLoaderRoute: typeof WithdrawAddressIndexImport
      parentRoute: typeof rootRoute
    }
    '/withdraw/amount/': {
      preLoaderRoute: typeof WithdrawAmountIndexImport
      parentRoute: typeof rootRoute
    }
    '/withdraw/confirm/': {
      preLoaderRoute: typeof WithdrawConfirmIndexImport
      parentRoute: typeof rootRoute
    }
    '/profile/wallet-settings/create-passkey/': {
      preLoaderRoute: typeof ProfileWalletSettingsCreatePasskeyIndexImport
      parentRoute: typeof rootRoute
    }
    '/profile/wallet-settings/create-session/': {
      preLoaderRoute: typeof ProfileWalletSettingsCreateSessionIndexImport
      parentRoute: typeof rootRoute
    }
    '/profile/wallet-settings/manage-passkeys/': {
      preLoaderRoute: typeof ProfileWalletSettingsManagePasskeysIndexImport
      parentRoute: typeof rootRoute
    }
    '/profile/wallet-settings/private-key/': {
      preLoaderRoute: typeof ProfileWalletSettingsPrivateKeyIndexImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  DepositIndexRoute,
  LoginSignupIndexRoute,
  OrdersIndexRoute,
  PortfolioIndexRoute,
  ProfileIndexRoute,
  RewardsIndexRoute,
  TradeIndexRoute,
  OrdersPendingPendingOrderIdRoute,
  MigrateForgotPasswordIndexRoute,
  MigrateInvalidIndexRoute,
  MigrateLoginIndexRoute,
  MigrateNoticeIndexRoute,
  MigratePasswordIndexRoute,
  MigrateTokensIndexRoute,
  OrdersOrderIdIndexRoute,
  ProfilePriorityFeeIndexRoute,
  ProfileQuickTradeSettingsIndexRoute,
  ProfileRpcIndexRoute,
  ProfileSlippageIndexRoute,
  ProfileTradeSettingsIndexRoute,
  ProfileUsernameIndexRoute,
  ProfileWalletSettingsIndexRoute,
  ProfileWsolIndexRoute,
  TradeConfirmIndexRoute,
  WithdrawAddressIndexRoute,
  WithdrawAmountIndexRoute,
  WithdrawConfirmIndexRoute,
  ProfileWalletSettingsCreatePasskeyIndexRoute,
  ProfileWalletSettingsCreateSessionIndexRoute,
  ProfileWalletSettingsManagePasskeysIndexRoute,
  ProfileWalletSettingsPrivateKeyIndexRoute,
])

/* prettier-ignore-end */
